<div class="kyc-modal">
  <!-- Use base template -->
  <div class="header" *ngIf="steps !== 'ERROR' && steps !== 'SUCCESS'">
    <div class="start">
      <mat-icon>
        {{
          steps === "TYPE-DOC"
            ? "description"
            : steps === "UPLOAD"
            ? "cloud_upload"
            : steps === "PROCESSING"
            ? "hourglass_empty"
            : steps === "IFRAME_VALIDATION"
            ? "security"
            : steps === "END_PROCESSING"
            ? "check_circle"
            : ""
        }}
      </mat-icon>
      <h3 class="title">
        {{
          (steps === "TYPE-DOC"
            ? "Select the type of document"
            : steps === "UPLOAD"
            ? ("Upload your document - " | translate) +
              (getDocumentTypeLabel(documentType!) ?? "" | translate)
            : steps === "PROCESSING"
            ? "Initializing Veriff verification..."
            : steps === "IFRAME_VALIDATION"
            ? "Complete your verification with Veriff"
            : steps === "END_PROCESSING"
            ? "Waiting for approval"
            : ""
          ) | translate
        }}
      </h3>
    </div>

    <div class="end">
      <mat-icon *ngIf="!data.isComponentView" (click)="close()">close</mat-icon>
    </div>
  </div>

  <!-- TYPE-DOC step -->
  <ng-container *ngIf="steps === 'TYPE-DOC'">
    <div class="container typedoc">
      <input-text-select
        [(ngModel)]="documentType"
        id="doctype"
        name="doctype"
        label="{{ 'Document Type' | translate }}"
        [options]="options"
      />
      <p class="text">
        {{ getProviderPrivacyNotice() }}
      </p>
    </div>
    <div class="footer">
      <button
        class="def-button alt"
        *ngIf="!data.isComponentView"
        (click)="close()"
      >
        {{ "Cancel" | translate }}
      </button>
      <button class="def-button" (click)="nextStep()">
        {{ "Next" | translate }}
      </button>
    </div>
  </ng-container>

  <!-- PROCESSING step (initializing Veriff session) -->
  <ng-container *ngIf="steps === 'PROCESSING'">
    <div class="container processing">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      <div class="processing-message">
        <p>{{ "Initializing Veriff verification session..." | translate }}</p>
      </div>
    </div>
  </ng-container>

  <!-- IFRAME_VALIDATION step (Veriff iframe) -->
  <ng-container *ngIf="steps === 'IFRAME_VALIDATION'">
    <div class="container iframe-validation">
      <div class="iframe-container">
        <iframe
          [src]="safeVeriffUrl"
          width="100%"
          height="600px"
          frameborder="0"
          allow="camera; microphone; geolocation"
          referrerpolicy="no-referrer"
        >
        </iframe>
      </div>
      <div class="iframe-info">
        <p>
          {{
            "Complete your verification in the frame above. Once completed, you will be automatically redirected."
              | translate
          }}
        </p>
        <div class="alternative-action">
          <p>
            {{
              "Having issues with the verification above? Try opening it in a new window."
                | translate
            }}
          </p>
          <button class="def-button alt" (click)="openVeriffInNewWindow()">
            {{ "Open verification in new window" | translate }}
          </button>
        </div>
      </div>
    </div>
    <div class="footer central">
      <button
        class="def-button alt"
        *ngIf="!data.isComponentView"
        (click)="close()"
      >
        {{ "Cancel" | translate }}
      </button>
      <button class="def-button" (click)="handleVeriffSuccess()">
        {{ "I've completed verification" | translate }}
      </button>
    </div>
  </ng-container>

  <!-- SUCCESS step -->
  <ng-container *ngIf="steps === 'SUCCESS'">
    <div class="container status success">
      <mat-icon>check_circle</mat-icon>
      <h3 class="title">
        {{ "Your identity verification has been completed successfully" | translate }}
      </h3>
      <p class="message">
        {{ messageService.getSuccessMessage('VERIFIED', data.provider) | translate }}
      </p>
      <p class="next-steps">
        {{ messageService.getNextStepsMessage() | translate }}
      </p>
    </div>
    <div class="footer central">
      <button class="def-button" (click)="close()">
        {{ "Proceed" | translate }}
      </button>
    </div>
  </ng-container>

  <!-- END_PROCESSING step -->
  <ng-container *ngIf="steps === 'END_PROCESSING'">
    <div class="container status success">
      <mat-icon>hourglass_empty</mat-icon>
      <h3 class="title">
        {{ "Your verification is still being processed" | translate }}
      </h3>
      <p class="message">
        {{ messageService.getPendingMessage() | translate }}
      </p>
    </div>
    <div class="footer central">
      <button class="def-button" (click)="close()">
        {{ "Proceed" | translate }}
      </button>
    </div>
  </ng-container>

  <!-- ERROR step -->
  <ng-container *ngIf="steps === 'ERROR'">
    <div class="container status error">
      <mat-icon>error</mat-icon>
      <h3 class="title">
        {{ currentError?.message || ("An error occurred during verification" | translate) }}
      </h3>
      <p class="suggested-action" *ngIf="currentError">
        {{ currentError.suggestedAction }}
      </p>
      <details *ngIf="isAgentSession && currentError && currentError.technicalDetails" class="technical-details">
        <summary>{{ "Technical Details" | translate }}</summary>
        <pre>{{ currentError.technicalDetails }}</pre>
      </details>
    </div>
    <div class="footer central">
      <button
        class="def-button alt"
        *ngIf="!data.isComponentView"
        (click)="close()"
      >
        {{ "Leave" | translate }}
      </button>
      <button
        *ngIf="currentError?.canRetry"
        class="def-button"
        (click)="nextStep()"
      >
        {{ "Try Again" | translate }}
      </button>
    </div>
  </ng-container>

  <!-- Test controls (dev only) -->
  <div class="test-controls" *ngIf="isDevEnvironment">
    <h4>{{ "Development Test Tools" | translate }}</h4>
    <div class="test-buttons">
      <button class="def-button" (click)="simulateVeriffCallback('success')">
        {{ "Simulate Success Callback" | translate }}
      </button>
      <button class="def-button alt" (click)="simulateVeriffCallback('error')">
        {{ "Simulate Error Callback" | translate }}
      </button>
    </div>
    <small>{{ "These controls are only visible in development mode" | translate }}</small>
  </div>
</div>
